import { contactForm, CustomerDetails, CustomerForm, CustomersState } from "../types";
import { initialListPaginationMeta } from "utils/helpers/pagination";

export const initialCustomerForm: CustomerForm = {
  customerName: "",
  category: "",
  contactPerson: "",
  contactPhone: "",
  contactEmail: "",
};


export const initialContactForm: contactForm = {
  contactName: "",
  role: "",
  phoneNo: "",
  email: "",
}



export const emptyCustomerDetails: CustomerDetails = {
  customerId: Number(""),
  customerName: "",
  customerShortName: "",
  category: "",
  contactPersonName: "",
  contactPhone: "",
  fax: "",
  address: "",
  moreDetails: "",
  activeWorkOrdersCount: Number(""),
  totalRevenue: Number(""),
  status: "draft",
  contacts: [
    {
      contactId: 1,
      customerId: Number(""),
      contactName: "",
      role: "",
      phoneNo: "",
      email: "",
      createdAt: "",
      updatedAt: null,
    },
    {
      contactId: 2,
      customerId: Number(""),
      contactName: "",
      role: "",
      phoneNo: "",
      email: "",
      createdAt: "",
      updatedAt: null,
    },
    {
      contactId: 3,
      customerId: Number(""),
      contactName: "",
      role: "",
      phoneNo: "",
      email: "",
      createdAt: "",
      updatedAt: null,
    },
  ],
  priceQuotes: [],
  workOrders: [],
  Financial: [],
  documents: [],
  timeline: [],
};

export const initialState: CustomersState = {
  loading: false,
  saving: false,
  list: [],
  statusFilter: "ALL",
  selectedCustomerId: null,
  customerDetails: null,
  detailLoading: false,
  error: null,
  isAddModalOpen: false,
  isAddContactModalOpen: false,
  isAddDocumentModalOpen: false,
  documentUploadFile: null,
  documentUploadError: "",
  form: initialCustomerForm,
  page: 1,
  perPage: 20,
  meta: initialListPaginationMeta,
  contactForm: initialContactForm,
  contactSaving: false
};
